import { Service } from "@roc/feature-app-core";
import { LeaseRow } from "../util/types";

const url = {
  GET_LEASE_INFO: '/api/v1/doc-review/leases/getLeaseInfo',
  SAVE_LEASE: '/api/v1/doc-review/leases/leaseRecords/save',
  UPLOAD_LEASES: '/api/v1/doc-review/leases/leaseRecords/upload',
  DOWNLOAD_LEASE: '/api/v1/doc-review/leases/leaseRecords/download',
  DELETE_LEASE: '/api/v1/doc-review/leases/leaseRecords/delete',
};

export class LeaseService extends Service {

  getLeaseInfo(loanId: number, propertyId: number) {
    return this.get(url.GET_LEASE_INFO, { loanId, propertyId });
  }

  saveLease(lease: Partial<LeaseRow>) {
    return this.post(url.SAVE_LEASE, lease);
  }

  uploadLeases(files: File[], loanId: number, propertyId: number, taskId: number) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    formData.append('loanId', String(loanId));
    formData.append('propertyId', String(propertyId));
    formData.append('taskId', String(taskId));
    return this.post(url.UPLOAD_LEASES, formData);
  }

  downloadLease(leaseId: number) {
    return this.get(url.DOWNLOAD_LEASE, { leaseId }, { responseType: 'arraybuffer' });
  }

  deleteLease(leaseId: number) {
    return this.delete(url.DELETE_LEASE, { leaseId });
  }

}